export const FETCH_VEHICLE_VARIANTS = "FETCH_VEHICLE_VARIANTS";
export const LOADING_SETTINGS = "LOADING_SETTINGS";
export const SETTINGS_ERROR = "SETTINGS_ERROR";
export const UPDATE_VARIANT = "UPDATE_VARIANT";
export const SAVING = "SAVING";
export const CREATE_VARIANT = "CREATE_VARIANT";
export const DELETE_VARIANT = "DELETE_VARIANT";
export const GET_VARIANT = "GET_VARIANT";